export default {
  FORM: {
    REQUIRED: 'Campo obrigatório.',
    INVALID_CNPJ: 'Informe um CNPJ válido.',
    UNCOMPLETED_CNPJ: 'Informe um CNPJ completo.',
  },
};
